import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataEdc() {
    return client.get("tunnel/api/pos/edc/data");
}

function getDataBank() {
    return client.get("tunnel/api/pos/edc/bank");
}

function addPembayaranEdc(params) {
    return client.post("tunnel/api/pos/edc/add", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function updatePembayaranEdc(params) {
    return client.post("tunnel/api/pos/edc/edit", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function deletePembayaranEdc(params) {
    return client.post("tunnel/api/pos/edc/delete", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

export default {
    getDataEdc,
    addPembayaranEdc,
    updatePembayaranEdc,
    deletePembayaranEdc,
    getDataBank
};